module.exports = __webpack_public_path__ + "img/manager.fca4564b.png";